import dayjs from 'dayjs'
import { sanitize } from 'isomorphic-dompurify'
export class LinkItem {
  constructor(item, url, isFavourite) {
    this.image = item.image || ''
    this.title = item.title
    this.handle = item.handle
    this.id = item.id
    this.isFavourite = isFavourite || false
    this.labels = item.labels || []
    this.url = url || ''
    this.publishedAt = item.published_at || null
    this.tags =
      typeof item.tags === 'string' ? item.tags.split(',') : item.tags || []
  }

  getMarkedTitle(word) {
    const sanitizedWord = sanitize(word)
    const sanitizedTitle = sanitize(this.title)
    return sanitizedWord
      ? sanitizedTitle.replace(sanitizedWord, `<mark>${sanitizedWord}</mark>`)
      : sanitizedTitle
  }

  get dateText() {
    return dayjs(this.publishedAt).format('YYYY月MM年DD日')
  }

  get isNew() {
    const now = new Date().getTime()
    const publishedAt = new Date(this.publishedAt).getTime()
    return now - publishedAt < 7 * 24 * 60 * 60 * 1000
  }
}
